import regexConfig from '../config/regex';

const addAttributeToEmailField = (html) => {
  const regex = regexConfig.EMAIL_FIELD;

  return html.replace(regex, '$1 klickbox-quiz-email-field');
};

export default addAttributeToEmailField;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/factories/addAttributeToEmailField.js
 **/